import { render, staticRenderFns } from "./Kosiwon.vue?vue&type=template&id=03e1b87b"
import script from "./Kosiwon.vue?vue&type=script&lang=js"
export * from "./Kosiwon.vue?vue&type=script&lang=js"
import style0 from "./Kosiwon.vue?vue&type=style&index=0&id=03e1b87b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports